(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4064],{

/***/ 6485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "RichTextEditorContent": function() { return /* reexport */ RichTextEditorContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/editorjs-html/build/edjsHTML.node.js
var edjsHTML_node = __webpack_require__(36873);
var edjsHTML_node_default = /*#__PURE__*/__webpack_require__.n(edjsHTML_node);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
;// CONCATENATED MODULE: ./src/images/arrow-down.svg
/* harmony default export */ var arrow_down = ({"src":"/_next/static/media/arrow-down.e043b6f2.svg","height":15,"width":19});
;// CONCATENATED MODULE: ./src/images/arrow-up.svg
/* harmony default export */ var arrow_up = ({"src":"/_next/static/media/arrow-up.c7400901.svg","height":15,"width":18});
;// CONCATENATED MODULE: ./src/components/atoms/Accordion/index.tsx






var AccordionLayout = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        borderTop: "1px solid black",
        borderBottom: "1px solid black",
        mt: "1rem",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
                onClick: function() {
                    return setIsOpen(function(_isOpen) {
                        return !_isOpen;
                    });
                },
                py: "1.5rem",
                w: "full",
                display: "flex",
                justifyContent: "space-between",
                cursor: "pointer",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        fontWeight: "bold",
                        children: isOpen ? "SHOW LESS" : "SHOW MORE"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                        cursor: "pointer",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_svg_esm/* ReactSVG */.Q, {
                            src: isOpen ? arrow_up.src : arrow_down.src
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                mt: "1rem",
                pb: "1rem",
                children: children
            })
        ]
    });
};
/* harmony default export */ var Accordion = (AccordionLayout);

;// CONCATENATED MODULE: ./src/components/atoms/RichTextEditorContent/RichTextEditorContent.tsx








var RichTextEditorContent = function(param) {
    var jsonData = param.jsonData, sanitizationNotRequired = param.sanitizationNotRequired, useAccordion = param.useAccordion;
    var ref;
    var html = "<div></div>";
    var accordionHtml = "<div></div>";
    var editorHtml = (0,react.useRef)(edjsHTML_node_default()());
    var data = jsonData ? JSON.parse(jsonData) : [];
    var htmlData = data;
    var isMonorepoEditorData = (data === null || data === void 0 ? void 0 : (ref = data.metadata) === null || ref === void 0 ? void 0 : ref.type) === "monorepo-editor";
    if (isMonorepoEditorData) {
        html = data.data;
    }
    try {
        if (useAccordion && Array.isArray(data === null || data === void 0 ? void 0 : data.blocks)) {
            var ref1, ref2, ref3, ref4;
            var firstHeaderIndex = data === null || data === void 0 ? void 0 : (ref1 = data.blocks) === null || ref1 === void 0 ? void 0 : ref1.findIndex(function(block) {
                return block.type === "header";
            });
            var secondHeaderIndex = data === null || data === void 0 ? void 0 : (ref2 = data.blocks) === null || ref2 === void 0 ? void 0 : ref2.findIndex(function(block, index) {
                return index !== firstHeaderIndex && block.type === "header";
            });
            htmlData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                blocks: data === null || data === void 0 ? void 0 : (ref3 = data.blocks) === null || ref3 === void 0 ? void 0 : ref3.slice(0, secondHeaderIndex)
            });
            var accordionHtmlData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                blocks: data === null || data === void 0 ? void 0 : (ref4 = data.blocks) === null || ref4 === void 0 ? void 0 : ref4.slice(secondHeaderIndex)
            });
            accordionHtml = editorHtml.current.parse(accordionHtmlData || []).join("");
        }
        html = editorHtml.current.parse(htmlData || []).join("");
    } catch (e) {
    // eslint-disable-line
    }
    // see: https://github.com/apostrophecms/sanitize-html
    // this in addition of strip <Script>s also handles problematic props eg, onClick
    if (!sanitizationNotRequired) {
        html = sanitize_html_default()(html, {
            allowedTags: sanitize_html_default().defaults.allowedTags.concat([
                "img"
            ]),
            allowedAttributes: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (sanitize_html_default()).defaults.allowedAttributes), {
                li: [
                    "class"
                ],
                span: [
                    "style",
                    "class"
                ]
            })
        });
        accordionHtml = sanitize_html_default()(accordionHtml, {
            allowedTags: sanitize_html_default().defaults.allowedTags.concat([
                "img"
            ]),
            allowedAttributes: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (sanitize_html_default()).defaults.allowedAttributes), {
                li: [
                    "class"
                ],
                span: [
                    "style",
                    "class"
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(chakra_ui_layout_esm/* Box */.xu, {
        sx: {
            ".ce-block__content": {
                maxWidth: "100%"
            },
            "*:last-child": {
                marginBottom: 0
            },
            p: {
                marginBottom: !isMonorepoEditorData && "1rem",
                fontSize: "18px",
                paddingBottom: "0.5rem"
            },
            h1: {
                marginBottom: "1.875rem"
            },
            h2: {
                marginBottom: !isMonorepoEditorData && "1.25rem",
                fontSize: "1.5rem",
                fontWeight: "600"
            },
            h3: {
                marginBottom: !isMonorepoEditorData && "1rem",
                fontWeight: "700",
                lineHeight: "1.6",
                padding: "0.5rem 0"
            },
            ol: {
                marginBottom: !isMonorepoEditorData && "2rem",
                marginLeft: "2rem",
                paddingLeft: "1rem"
            },
            ul: {
                marginBottom: !isMonorepoEditorData && "2rem",
                marginLeft: "2rem",
                paddingLeft: "1rem"
            },
            "ol li": {
                listStyleType: "decimal",
                marginBottom: !isMonorepoEditorData && "0.5rem",
                paddingLeft: "0.5rem",
                padding: "0.5rem 0"
            },
            "ul li": {
                listStyleType: "disc",
                marginBottom: !isMonorepoEditorData && "0.5rem",
                padding: "0.5rem 0",
                fontSize: "18px"
            },
            ".ql-indent-1": {
                marginLeft: "4.5em"
            },
            ".ql-indent-2": {
                marginLeft: "7.5em"
            },
            a: {
                color: "#06c",
                transition: "color 0.3s, text-decoration 0.3s",
                "&:hover": {
                    textDecoration: "underline"
                }
            },
            "@media screen and (min-width: 30rem)": {
                h2: {
                    fontSize: "2rem"
                },
                h3: {
                    fontSize: "22.5px"
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                dangerouslySetInnerHTML: {
                    __html: html
                },
                sx: {
                    lineHeight: "1.42"
                }
            }),
            useAccordion && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                    dangerouslySetInnerHTML: {
                        __html: accordionHtml
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/RichTextEditorContent/index.ts



/***/ }),

/***/ 22868:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 14777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 99830:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 70209:
/***/ (function() {

/* (ignored) */

/***/ })

}]);